import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
interface Testimonial {
  name: string;
  location: string;
  role?: string;
  text: string;
}
interface TestimonialsProps {
  testimonials: Testimonial[];
}
export function Testimonials({
  testimonials
}: TestimonialsProps) {
  return <section className="w-full bg-[#FAF0DE] py-4 md:py-8" data-id="element-279">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-280">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4" data-id="element-281">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-white border border-[#E8D5BA] rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow" data-id="element-282">
              <div className="flex gap-1 mb-2" data-id="element-283">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-[#D4A373] text-[#D4A373]" data-id="element-284" />)}
              </div>
              <p className="text-[#6B5747] mb-2 leading-relaxed text-sm" data-id="element-285">
                "{testimonial.text}"
              </p>
              <div className="text-sm" data-id="element-286">
                <p className="text-[#3D2817] font-semibold" data-id="element-287">
                  {testimonial.name}
                </p>
                <p className="text-[#9B8770] text-xs" data-id="element-288">
                  {testimonial.location}
                  {testimonial.role && ` · ${testimonial.role}`}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}